module fdm.templates {
    angular.module('fdm.templates', []);
}